import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { SiteNoteService } from '@core/api/site-note.service';
import * as fromApp from '@store';
import { SiteNote, User } from '@shared/models';

@Component({
  selector: 'fc-dialog-edit-site-note',
  templateUrl: './dialog-edit-site-note.component.html',
  styleUrl: './dialog-edit-site-note.component.scss',
  standalone: false
})
export class DialogEditSiteNoteComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  editSiteNote: UntypedFormGroup;
  note: SiteNote = null;
  siteId: number = null;
  currentUser: User = null;

  categories: string[] = [];

  constructor(
    readonly store: Store<fromApp.AppState>,
    public dialogRef: MatDialogRef<DialogEditSiteNoteComponent>,
    public dialog: MatDialog,
    public siteNoteService: SiteNoteService,
    readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.note = data.siteNote;
    this.siteId = data.siteId;
    this.categories = data.categories;
    this.currentUser = data.currentUser;
  }

  ngOnInit(): void {
    this.editSiteNote = this.formBuilder.group({
      note: new FormControl(this.note?.note, Validators.required),
      category: new FormControl(this.note?.category, Validators.required),
      needsReview: new FormControl(this.note?.needsReview),
    });
    if (!this.currentUser?.isWriteAdmin && this.note && this.note.userId !== this.currentUser?.id) {
      this.editSiteNote.get('note').disable();
      this.editSiteNote.get('category').disable();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    let updateNote: SiteNote = new SiteNote({
      note: this.editSiteNote.value.note,
      siteId: this.siteId,
      category: this.editSiteNote.value.category,
      needsReview: this.editSiteNote.value.needsReview,
    });
    if (this.note) {
      updateNote.id = this.note.id;
      this.siteNoteService.updateSiteNote(updateNote).subscribe((newNote: SiteNote) => {
        this.dialogRef.close(newNote);
      });
    } else {
      this.siteNoteService.createSiteNote(updateNote).subscribe((newNote: SiteNote) => {
        this.dialogRef.close(newNote);
      });
    }
  }
}
